// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1898 ? "28efd8eb" : chunkId) + "." + {"1898":"02b09d891cd8e2a3","4111":"b93548b1b04e34e4","7030":"cf644a7296b5fa78","8471":"8862c56addc2455f"}[chunkId] + ".js";
};